import Icon from '../components/Icon.vue'

Icon.register({
  plane: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M480 192H365.7L260.6 8.1A16-16 0 0 1 246.7 0H181.2C170.6 0 162.9 10.2 165.8 20.4L214.9 192H112L68.8 134.4C65.8 130.4 61 128 56 128H16C5.6 128-2 137.8 0.5 147.9L32 256 0.5 364.1C-2 374.2 5.6 384 16 384H56C61 384 65.8 381.6 68.8 377.6L112 320H214.9L165.8 491.6C162.9 501.8 170.6 512 181.2 512H246.7C252.4 512 257.8 508.9 260.6 503.9L365.7 320H480C515.4 320 576 291.4 576 256S515.4 192 480 192z'
      }
    ]
  }
})
